import KathmanduLandingPage from './KathmanduLandingPage';

export default KathmanduLandingPage;
